(function($){

    $(function () {

        // fade in main menu on page load
           function show_menu(){
              $("#mainMenu").animate({opacity: '1'}, 300, 'linear');
           };
           window.setTimeout( show_menu, 250 );


        // Mobile menu animations
        $('#triggerContainer').on('click', function(){

            // close menu
            if($(this).hasClass('open')){

                $(this).removeClass('open');
                $('#trigger').removeClass('open');
                $('body').removeClass('disable');
                $('html').removeClass('disable');
                $('#mainMenu').animate({right: '-100vw'}, 300, 'linear');

            // open menu
            } else {

                $('body').addClass('disable');
                $('html').addClass('disable');
                $('#mainMenu').animate({right: '0px'}, 300, 'linear');
                $('#trigger').addClass('open');
                $(this).addClass('open');

            }

        });


        // Add a <span> to every menu-item that has a <ul> inside
        $('#mainMenu .menu > li.menu-item-has-children > a').prepend('<span class="nav-click"><i class="fa-regular fa-chevron-down"></i></span>');

        // dynamic binding to on 'click'
        $('#mainMenu .menu > li.menu-item-has-children > a').on('click', '.nav-click', function(e){
            e.preventDefault();
            // Toggle the nested nav
            $(this).toggleClass('opened');
            $(this).parent().next('.sub-menu').slideToggle();
        });



        // Go to top button
        $(window).scroll(function() {
            if ($(this).scrollTop() > 600){
                $('#goTop').addClass("active");
            } else {
                $('#goTop').removeClass("active");
            }
        });


        // Scroll on click
        $(document).on('click', 'a.skip-link', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 1000);
        });


        // Remove empty paragraphs
        $('p:empty:not([role])').remove();


        // Remove p tags around images when using the WYSIWYG advanced custom field
        $('p > img').unwrap();


        // Fancybox
        Fancybox.bind('[data-fancybox="gallery"]', {
            Images: {
                protected: true
            },
        }); 

    });

})(jQuery);


/**
 * Overflow Menu Handler
 * Manages menu items overflow by moving items between main menu and overflow menu
 */
(function() {
    'use strict';

    const MENU_ITEM_PADDING = 16; // 8px left + 8px right
    const MAIN_MENU_PADDING = 40; // 20px left + 20px right
    
    let resizeTimeout;

    /**
     * Calculate the total width needed for menu items
     */
    function getMenuItemsWidth(items) {
        let totalWidth = 0;
        items.forEach(item => {
            const itemWidth = item.offsetWidth; // offsetWidth already includes padding
            totalWidth += itemWidth;
        });
        return totalWidth;
    }

    /**
     * Get available width for menu items
     */
    function getAvailableWidth() {
        const mainMenu = document.getElementById('mainMenu');
        const overflowContainer = mainMenu.querySelector('.overflow-menu-container');
        
        if (!mainMenu) return 0;
        
        const totalWidth = mainMenu.offsetWidth - MAIN_MENU_PADDING;
        const overflowWidth = overflowContainer ? overflowContainer.offsetWidth : 0;
        
        return totalWidth - overflowWidth;
    }

    /**
     * Move items to overflow menu
     */
    function moveToOverflow() {
        const mainMenuUl = document.getElementById('main-menu');
        const overflowMenu = document.querySelector('.overflow-menu');
        const overflowContainer = document.querySelector('.overflow-menu-container');
        
        if (!mainMenuUl || !overflowMenu || !overflowContainer) return;

        const mainMenuItems = Array.from(mainMenuUl.children);
        if (mainMenuItems.length === 0) return;
        
        const availableWidth = getAvailableWidth();
        const currentWidth = getMenuItemsWidth(mainMenuItems);
        
        // If items fit, don't move anything
        if (currentWidth <= availableWidth) return;
        
        // Move last item to overflow
        const lastItem = mainMenuItems[mainMenuItems.length - 1];
        overflowMenu.insertBefore(lastItem, overflowMenu.firstChild);
        
        // Force a reflow and check again
        void overflowContainer.offsetWidth;
        
        // Recursively check if more items need to be moved
        const remainingItems = Array.from(mainMenuUl.children);
        if (remainingItems.length > 0) {
            const newCurrentWidth = getMenuItemsWidth(remainingItems);
            const newAvailableWidth = getAvailableWidth();
            
            if (newCurrentWidth > newAvailableWidth) {
                moveToOverflow();
            }
        }
    }

    /**
     * Move items back from overflow menu to main menu
     */
    function moveFromOverflow() {
        const mainMenuUl = document.getElementById('main-menu');
        const overflowMenu = document.querySelector('.overflow-menu');
        const overflowContainer = document.querySelector('.overflow-menu-container');
        
        if (!mainMenuUl || !overflowMenu || !overflowContainer) return;

        const overflowItems = Array.from(overflowMenu.children);
        if (overflowItems.length === 0) return;

        const availableWidth = getAvailableWidth();
        const mainMenuItems = Array.from(mainMenuUl.children);
        
        let currentWidth = getMenuItemsWidth(mainMenuItems);
        let itemsMoved = false;

        // Try to move items back from overflow
        for (let i = 0; i < overflowItems.length; i++) {
            const item = overflowItems[i];
            const itemWidth = item.offsetWidth; // offsetWidth already includes padding
            
            if (currentWidth + itemWidth <= availableWidth) {
                mainMenuUl.appendChild(item);
                currentWidth += itemWidth;
                itemsMoved = true;
            } else {
                break;
            }
        }

        // Hide overflow container if empty
        if (overflowMenu.children.length === 0) {
            overflowContainer.style.display = 'none';
        }

        return itemsMoved;
    }

    /**
     * Check and adjust menu overflow
     */
    function checkOverflow() {
        // Only run if window is 1200px or wider
        if (window.innerWidth < 1200) return;
        
        const mainMenu = document.getElementById('mainMenu');
        const mainMenuUl = document.getElementById('main-menu');
        const overflowMenu = document.querySelector('.overflow-menu');
        const overflowContainer = document.querySelector('.overflow-menu-container');
        
        if (!mainMenu || !mainMenuUl || !overflowMenu || !overflowContainer) return;

        // First, try to move items back from overflow (skip on initial load)
        if (overflowMenu.children.length > 0) {
            let itemsMoved = true;
            while (itemsMoved && overflowMenu.children.length > 0) {
                itemsMoved = moveFromOverflow();
            }
        }

        // Show overflow container temporarily to calculate accurate available width
        const wasHidden = overflowContainer.style.display === 'none';
        if (wasHidden) {
            overflowContainer.style.display = 'inline-block';
        }
        
        // Lock the main menu width to prevent it from shrinking as items are moved
        const mainMenuWidth = mainMenu.offsetWidth;
        mainMenu.style.width = mainMenuWidth + 'px';
        
        // Lock the overflow container width to prevent it from growing as items are added
        // Remove any previous width constraints first
        overflowContainer.style.minWidth = '';
        overflowContainer.style.maxWidth = '';
        overflowContainer.style.width = '';
        
        // Get the natural width and lock it
        const overflowContainerWidth = overflowContainer.offsetWidth;
        overflowContainer.style.width = overflowContainerWidth + 'px';
        overflowContainer.style.flexShrink = '0';

        // Then check if we need to move items to overflow
        const mainMenuItems = Array.from(mainMenuUl.children);
        const availableWidth = getAvailableWidth();
        const currentWidth = getMenuItemsWidth(mainMenuItems);

        if (currentWidth > availableWidth) {
            moveToOverflow();
        } else if (wasHidden) {
            // No overflow needed, hide the container again
            overflowContainer.style.display = 'none';
        }

        // Final check: Show/hide overflow container based on whether it has items
        if (overflowMenu.children.length > 0) {
            overflowContainer.style.display = 'inline-block';
        } else {
            overflowContainer.style.display = 'none';
        }
        
        // Remove width lock from main menu
        mainMenu.style.width = '';
    }

    /**
     * Handle resize events with debouncing
     */
    function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(checkOverflow, 150);
    }

    /**
     * Initialize the overflow menu handler
     */
    function init() {
        // Show overflow container to get accurate measurements, but make it invisible
        const overflowContainer = document.querySelector('.overflow-menu-container');
        if (overflowContainer) {
            overflowContainer.style.visibility = 'hidden';
            overflowContainer.style.display = 'inline-block';
        }

        // Small delay to ensure menu is rendered and visible
        setTimeout(() => {
            // Check overflow on load
            checkOverflow();
            
            // Make overflow container visible again
            if (overflowContainer) {
                overflowContainer.style.visibility = 'visible';
            }
        }, 300);

        // Add resize listener
        window.addEventListener('resize', handleResize);
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();